export const workQueryKeys = {
  root: ['work'] as const,
  projects: {
    root: ['projects'] as const,
    list: (filters: object = {}) => ['projects', 'list', filters] as const,
    options: ['projects', 'options'] as const,
  },
  tasks: {
    root: ['tasks'] as const,
    list: (filters: object = {}) => ['tasks', 'list', filters] as const,
    mine: ['tasks', 'mine'] as const,
    detail: (id: string | null) => ['tasks', 'detail', id] as const,
  },
  demos: {
    root: ['demos'] as const,
    list: (filters: object = {}) => ['demos', 'list', filters] as const,
    detail: (id: string | null) => ['demos', 'detail', id] as const,
    analytics: ['demos', 'analytics'] as const,
  },
  dcms: { root: ['dcms'] as const, list: ['dcms', 'list'] as const },
  timeLogs: {
    root: ['attendance'] as const,
    list: (filters: object = {}) => ['attendance', 'logs', filters] as const,
    today: (userId?: string) => ['attendance', 'today', userId ?? null] as const,
    team: (department?: string) => ['attendance', 'team', department ?? null] as const,
    dashboard: ['attendance', 'dashboard'] as const,
  },
  activity: {
    root: ['activity'] as const,
    feed: (filters: object = {}) => ['activity', 'feed', filters] as const,
    mine: ['activity', 'mine'] as const,
    entity: (type: string, id: string | null) => ['activity', 'entity', type, id] as const,
  },
  notifications: {
    root: ['notifications'] as const,
    list: (limit: number) => ['notifications', limit] as const,
  },
  ai: { root: ['ai'] as const, insight: (name: string) => ['ai', name] as const },
  upload: { root: ['upload'] as const },
} as const;
